<ion-header>
    <ion-toolbar>
        <ion-button fill="clear" slot="start" (click)="close()">
            Cancel
        </ion-button>
        <ion-title>Share Your QR</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>
    <div sxCol sxAlign="center" sxWidth="full" sxPadding="10px 0px 0px 0px">
        <div
            #qrwrapper
            class="export-qr-view"
            sxCol
            sxAlign="center"
            sxPadding="15px 40px 0 40px"
            sxWidth="350px"
            sxRadius="30px">
            <p sxMargin="0" sxColor="#7e7e7e">Share IDs with</p>
            <img
                    sxWidth="100px"
                    sxMargin="10px 0 15px"
                    src="assets/imgs/qid-text-white.png"/>
            <div
                    sxColor="black"
                    sxBackground="white"
                    sxRadius="20px 20px 0 0"
                    sxCol
                    sxAlign="center"
                    sxPadding="medium">
                <!--                <ngx-qrcode-->
                <!--                        *ngIf="!loading && template"-->
                <!--                        [value]="baseUrl + scanner.qr"-->
                <!--                        [margin]="2"-->
                <!--                        [width]="220"></ngx-qrcode>-->

                <h1 sxMargin="5px 0" sxTextSize="medium">{{ template?.org?.name }}</h1>
                <p sxMargin="5px 0" sxTextSize="small">{{ template?.purpose }}</p>
                <img
                        sxWidth="100px"
                        sxMargin="10px 0 0 0"
                        src="assets/imgs/secure-icon.png"/>
            </div>
        </div>
        <div sxRow sxWidth="full" sxPadding="medium" sxGap="10px">
            <super-button
                    sxWidth="fill"
                    iconStart="share-outline"
                    background="light"
                    color="dark"
                    [action]="share.bind(this, template)"
            >Share
            </super-button>
            <super-button
                    sxWidth="fill"
                    iconStart="qr-code-outline"
                    background="light"
                    color="dark"
                    [action]="shareToLocal"
            >Download
            </super-button>
        </div>
    </div>
</ion-content>
